
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#FFF","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M13.774 2.2L9.912 6.063l.911.911 3.863-3.862c.015.542.106 1.08.271 1.598l1.058-.177a11.471 11.471 0 01-.314-3.348 11.471 11.471 0 01-3.346-.316l-.178 1.059a5.785 5.785 0 001.597.272z","fill":"#FFF","fill-rule":"nonzero","stroke-width":".5"}}),_c('path',{attrs:{"stroke-width":"2","d":"M8.358 3.008H1.001v11h14.2V6.983"}})])])
          )
        }
      }
    